import { render, staticRenderFns } from "./RealIntentionConfirm.vue?vue&type=template&id=233c509b"
import script from "./RealIntentionConfirm.vue?vue&type=script&lang=js"
export * from "./RealIntentionConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports